import React from "react";
import axios from "axios";
// import { GoogleLogin } from '@react-oauth/google';
import { useGoogleLogin } from '@react-oauth/google';
import { useLanguage } from "../LanguageContext";

function LoginGoogle(props){
  const { t } = useLanguage();

    const login = useGoogleLogin({
        onSuccess: (codeResponse) => googleLoginSuccess(codeResponse),
        onError: (error) => googleLoginError(error)
    });

    // The server independently verifies accessToken with Google and uses the email
    // Google returns for it - the `user` object below is only used for cosmetic
    // display-name purposes, never trusted for identity/login.
    function loginGoogleUser(user, accessToken){
        axios({
          method: "POST",
          data: {
            user: user,
            accessToken: accessToken,
            ip: props.addressIp
          },
          withCredentials: true,
          url: process.env.REACT_APP_SERVER_URL + process.env.REACT_APP_LOGIN_GOOGLEUSER_URL,
        }).then((res) => {
          props.loginResponse(res);
        }).catch((err) =>{
          if (err.response?.data?.banned) {
            props.loginResponse(err.response);
            return;
          }
          console.log(err);
        });
      }

    function googleLoginSuccess(codeResponse){
      getGoogleUser(codeResponse);
    }

    function getGoogleUser(codeResponse){
      axios
                      .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${codeResponse.access_token}`, {
                          headers: {
                              Authorization: `Bearer ${codeResponse.access_token}`,
                              Accept: 'application/json'
                          }
                      })
                      .then((res) => {
                          loginGoogleUser(res.data, codeResponse.access_token);
                      })
                      .catch((err) => console.log(err));
    }
  
    function googleLoginError(error){
      console.log("login error: " + error);
    }

    return (
        <div className="card-body">
          {/* <a className="btn btn-block btn-social btn-google" onClick={props.googleButton} role="button"> */}
          <button type="button" className="btn btn-block btn-social btn-google" onClick={() => login()}>
            {/* <i className="fab fa-google company-icon"></i> */}
            <img className="socialLogo" src="images/google.png" alt="" />
            {t(props.textKey ?? "loginWithGoogle")}
          </button>
        </div>
    )
}

export default LoginGoogle;